import React, { Suspense } from 'react';
import styled from 'react-emotion';
import { withRouter, Switch, Route } from 'react-router-dom';
import P from 'prop-types';

import { withConfiguration } from '../contexts/ConfigurationContext';
import Spinner from '../UI/components/Spinner/Spinner';
import ProtectedRoute from '../UI/components/ProtectedRoute/ProtectedRoute';
import PageNotFound from './Error/PageNotFound';

const Home = React.lazy(() => import(/* webpackChunkName: "Home" */ './Home/Home'));
const Legal = React.lazy(() => import(/* webpackChunkName: "Legal" */ './Legal/Legal'));
const Payment = React.lazy(() => import(/* webpackChunkName: "Payment" */ './Payment/Payment'));
const Auth = React.lazy(() => import(/* webpackChunkName: "Auth" */ './Auth/Auth'));

const Wrapper = styled('div')`
   width: 100vw;
   height: 100vh;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
`;

export class App extends React.Component {
   render() {
      return !this.props.configuration.loaded ? (
         <Wrapper>
            <Spinner size={128} />
         </Wrapper>
      ) : this.props.configuration.hasFailed ? (
         <PageNotFound />
      ) : (
         <Suspense fallback={<div />}>
            <Switch>
               <ProtectedRoute path="/home" render={() => <Home />} />
               <ProtectedRoute path="/payment" render={() => <Payment />} />
               <Route path="/legal" render={() => <Legal />} />
               <Route path="/404" render={() => <PageNotFound />} />
               <Route path="/" render={() => <Auth />} />
            </Switch>
         </Suspense>
      );
   }
}

App.propTypes = {
   configuration: P.any
};

export default withRouter(withConfiguration(App));



// WEBPACK FOOTER //
// ./src/App/App.js